import { Dimensions } from '@features/virtual-tour/types';

import { CanvasStyle, HouseSelectorPolygon } from './types';

type RepaintState = {
    styles?: CanvasStyle | null;
    dimensions?: Dimensions | null;
    hoverPolygons?: HouseSelectorPolygon[] | null;
};

export const useCanvasRepaint = (options: { onRepaint: Function }) => {
    const state: RepaintState = {};

    const canRepaint = (): boolean => {
        return !!state.styles && !!state.dimensions;
    };

    const setState = (newState: Partial<RepaintState>) => {
        Object.assign(state, newState);
        requestRepaint();
    };

    const getState = () => state;

    const requestRepaint = () => {
        if (!canRepaint()) return;
        options.onRepaint();
    };

    return { setState, getState, requestRepaint };
};
